'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var XIcon_module = require('./XIcon.module.css.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

const XIcon = ({
  s
}) => /*#__PURE__*/React__default["default"].createElement("svg", {
  className: XIcon_module["default"].container,
  style: {
    fill: s?.color,
    ...s
  },
  viewBox: "0 0 10 10",
  role: "presentation"
}, /*#__PURE__*/React__default["default"].createElement("path", {
  d: "M9 1.8L8.2 1 5 4.2 1.8 1l-.8.8L4.2 5 1 8.2l.8.8L5 5.8 8.2 9l.8-.8L5.8 5"
}));

exports["default"] = XIcon;
